<form [formGroup]="formGroup">
  <app-dc-date-input
    id="id"
    formControlName="editedDate"
    type="text"
    container="body"
  ></app-dc-date-input>
</form>
